/* UGC « Vu en action » : previews + lightbox (voir snippets/cluutch-ugc-reels.liquid).
   L'ajout panier est délégué au custom element <product-form> du thème (assets/product.js),
   qui re-rend et OUVRE le cart drawer (z 90) par-dessus la lightbox (z 80) : la vidéo continue.
   Contraintes thème respectées :
   - scroll-lock via classe dédiée body.cluutch-ugc-open (open-cc appartient aux side panels) ;
   - Escape : si le drawer est ouvert (body.open-cart), on laisse le keyup global du thème le
     fermer (panel:close) et on ne ferme pas la lightbox ;
   - le .click-capture du thème (z 52) est sous la lightbox : le clic hors-drawer est proxifié.
   Tutos de teinte (habillage de collection, Hôtel Charly, 06/10/2026) : les `li` marqués
   `data-cluutch-variante` ne sont rendus que pour les variantes habillées qui ont un tuto, et
   masqués hors de leur teinte. Tout ce qui compte les tuiles (ouverture, points, pas des flèches,
   visionneuse) ne compte que les visibles ; sans tuto de teinte, elles le sont toutes et rien ne
   change. */
if (!customElements.get('cluutch-ugc-reels')) {
	class CluutchUgcReels extends HTMLElement {
		connectedCallback() {
			this.track = this.querySelector('.cluutch-ugc__track');
			this.tiles = [...this.querySelectorAll('.cluutch-ugc__tile')];
			this.previews = [...this.querySelectorAll('.cluutch-ugc__preview')];
			this.tpl = this.querySelector('.cluutch-ugc__lightbox-tpl');
			this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			this.lb = null;
			this.index = 0;

			this.setupPreviews();
			this.setupRail();
			this.tiles.forEach((tile) => {
				tile.addEventListener('click', () => this.open(this.visibles().indexOf(tile)));
			});
			document.addEventListener('product:variant-change', (e) => this.onVariantChange(e));
			this.teintes = [...this.querySelectorAll('[data-cluutch-variante]')];
			if (this.teintes.length) document.addEventListener('product:variant-change', (e) => this.onTeinte(e));
		}
		// Les tuiles dont le `li` n'est pas masqué (tutos des autres teintes).
		visibles() {
			return this.tiles.filter((tile) => !tile.parentElement.hidden);
		}
		setupPreviews() {
			if (this.reduceMotion) return;
			this.io = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					const video = entry.target;
					if (entry.intersectionRatio >= 0.5 && !this.isOpen()) {
						video.play().catch(() => {});
					} else {
						video.pause();
					}
				});
			}, { threshold: [0, 0.5] });
			this.previews.forEach((v) => this.io.observe(v));
		}
		setupRail() {
			const prev = this.querySelector('.cluutch-ugc__arrow--prev');
			const next = this.querySelector('.cluutch-ugc__arrow--next');
			const step = () => {
				const premiere = this.visibles()[0];
				return premiere ? premiere.getBoundingClientRect().width + 8 : 160;
			};
			[prev, next].forEach((btn) => {
				btn.addEventListener('click', () => {
					this.track.scrollBy({ left: step() * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
				});
			});
			const syncArrows = () => {
				prev.hidden = this.track.scrollLeft <= 4;
				next.hidden = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
			};
			this.track.addEventListener('scroll', syncArrows, { passive: true });
			syncArrows();
			this.syncArrows = syncArrows;
		}
		isOpen() {
			return !!(this.lb && this.lb.isConnected && document.body.classList.contains('cluutch-ugc-open'));
		}
		hydrate() {
			if (this.lb) return;
			this.lb = this.tpl.content.firstElementChild.cloneNode(true);
			document.body.appendChild(this.lb);
			this.video = this.lb.querySelector('.cluutch-ugc-lb__frame video');
			this.progress = this.lb.querySelector('.cluutch-ugc-lb__progress span');
			this.timeCurrent = this.lb.querySelector('[data-ugc-current]');
			this.timeDuration = this.lb.querySelector('[data-ugc-duration]');
			this.dots = this.lb.querySelector('.cluutch-ugc-lb__dots');

			this.lb.querySelector('.cluutch-ugc-lb__close').addEventListener('click', () => this.close());
			this.lb.querySelectorAll('.cluutch-ugc-lb__nav button').forEach((btn) => {
				btn.addEventListener('click', () => this.go(parseInt(btn.dataset.dir, 10)));
			});
			this.lb.querySelector('.cluutch-ugc-lb__mute').addEventListener('click', () => {
				this.video.muted = !this.video.muted;
				this.syncMuteUi();
			});
			this.video.addEventListener('loadedmetadata', () => {
				this.timeDuration.textContent = this.fmt(this.video.duration);
			});
			this.video.addEventListener('canplay', () => this.lb.classList.add('is-video-ready'));

			// Clic sur le fond : ferme le drawer s'il est ouvert (le .click-capture z52 du thème
			// est sous la lightbox), sinon ferme la lightbox.
			this.lb.addEventListener('click', (e) => {
				if (document.body.classList.contains('open-cart')) {
					const closeBtn = document.querySelector('#Cart-Drawer .side-panel-close');
					if (closeBtn) closeBtn.click();
					e.stopPropagation();
				} else if (e.target === this.lb || e.target.classList.contains('cluutch-ugc-lb__zone')) {
					this.close();
				}
			});
			this.onKey = (e) => {
				if (e.key !== 'Escape' || !this.isOpen()) return;
				if (document.body.classList.contains('open-cart')) return; // le thème ferme le drawer
				this.close();
			};
			document.addEventListener('keyup', this.onKey);
			this.onTrap = (e) => {
				if (e.key !== 'Tab' || !this.isOpen()) return;
				if (document.body.classList.contains('open-cart')) return; // laisser Tab aller au drawer
				const focusables = [...this.lb.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])')]
					.filter((el) => !el.disabled && el.offsetParent !== null);
				if (!focusables.length) return;
				const first = focusables[0];
				const last = focusables[focusables.length - 1];
				if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
				else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
			};
			document.addEventListener('keydown', this.onTrap);

			// Swipe vertical (mobile) : vidéo suivante/précédente, ignoré dans le panneau.
			let touchY = null, touchX = null;
			const zone = this.lb.querySelector('.cluutch-ugc-lb__zone');
			zone.addEventListener('touchstart', (e) => {
				touchY = e.touches[0].clientY;
				touchX = e.touches[0].clientX;
			}, { passive: true });
			zone.addEventListener('touchend', (e) => {
				if (touchY === null) return;
				const dy = e.changedTouches[0].clientY - touchY;
				const dx = e.changedTouches[0].clientX - touchX;
				if (Math.abs(dy) >= 60 && Math.abs(dy) > Math.abs(dx)) this.go(dy < 0 ? 1 : -1);
				touchY = touchX = null;
			}, { passive: true });
		}
		open(index) {
			this.hydrate();
			this.lb.hidden = false;
			if (document.body.classList.contains('open-cart')) {
				const closeBtn = document.querySelector('#Cart-Drawer .side-panel-close');
				if (closeBtn) closeBtn.click();
			}
			this.previews.forEach((v) => v.pause());
			this.opener = document.activeElement;
			this.syncVariantFromMainForm();
			// La visionneuse parcourt les tuiles visibles à l'ouverture, un point chacune.
			this.liste = this.visibles();
			this.dots.replaceChildren(...this.liste.map(() => document.createElement('i')));
			this.setVideo(index);
			document.body.classList.add('cluutch-ugc-open');
			// backdrop d'abord, puis le panneau entre (la zone vidéo rétrécit en douceur)
			requestAnimationFrame(() => requestAnimationFrame(() => this.lb.classList.add('is-open')));
			this.video.muted = false;
			this.video.play().catch(() => {
				this.video.muted = true;
				this.video.play().catch(() => {});
				this.syncMuteUi();
			});
			this.syncMuteUi();
			this.lb.querySelector('.cluutch-ugc-lb__close').focus();
			this.tickLoop();
		}
		setVideo(index) {
			this.index = Math.max(0, Math.min(index, this.liste.length - 1));
			const tile = this.liste[this.index];
			this.lb.classList.remove('is-video-ready');
			this.video.poster = tile.dataset.poster;
			this.video.src = tile.dataset.src;
			this.progress.style.transform = 'scaleX(0)';
			this.timeCurrent.textContent = '0:00';
			this.timeDuration.textContent = '0:00';
			[...this.dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
			const [up, down] = this.lb.querySelectorAll('.cluutch-ugc-lb__nav button');
			up.disabled = this.index === 0;
			down.disabled = this.index === this.liste.length - 1;
		}
		go(dir) {
			const next = this.index + dir;
			if (next < 0 || next >= this.liste.length) return;
			const wasMuted = this.video.muted;
			this.setVideo(next);
			this.video.muted = wasMuted;
			this.video.play().catch(() => {});
		}
		tickLoop() {
			cancelAnimationFrame(this.raf);
			const tick = () => {
				if (!this.isOpen()) return;
				if (this.video.duration) {
					this.progress.style.transform = 'scaleX(' + this.video.currentTime / this.video.duration + ')';
					this.timeCurrent.textContent = this.fmt(this.video.currentTime);
				}
				this.raf = requestAnimationFrame(tick);
			};
			this.raf = requestAnimationFrame(tick);
		}
		fmt(s) {
			if (!isFinite(s)) return '0:00';
			const m = Math.floor(s / 60);
			const sec = Math.floor(s % 60);
			return m + ':' + String(sec).padStart(2, '0');
		}
		syncMuteUi() {
			this.lb.classList.toggle('is-sound-on', !this.video.muted);
			const btn = this.lb.querySelector('.cluutch-ugc-lb__mute');
			btn.setAttribute('aria-label', this.video.muted ? (btn.dataset.labelUnmute || 'Activer le son') : (btn.dataset.labelMute || 'Couper le son'));
		}
		syncVariantFromMainForm() {
			const mainInput = document.querySelector('#product-form-' + this.dataset.section + ' input[name="id"], #product-form-' + this.dataset.section + ' [name="id"]');
			const ourInput = this.lb.querySelector('form [name="id"]');
			if (mainInput && ourInput) ourInput.value = mainInput.value;
			// `#price-<section>` est rendu par product-information.liquid sur la fiche native comme
			// sur la fiche 2026 (cluutch-pdp), qui n'a pas d'ancêtre `.thb-product-detail`.
			const mainPrice = document.querySelector('#price-' + this.dataset.section + ' .price');
			const ourPrice = this.lb.querySelector('[data-ugc-price]');
			if (mainPrice && ourPrice) ourPrice.innerHTML = mainPrice.innerHTML;
		}
		onVariantChange(e) {
			if (!this.lb || !e.detail || !e.detail.variant) return;
			const ourInput = this.lb.querySelector('form [name="id"]');
			if (ourInput) ourInput.value = e.detail.variant.id;
			const atc = this.lb.querySelector('.cluutch-ugc-lb__atc');
			const label = atc.querySelector('.single-add-to-cart-button--text');
			atc.disabled = !e.detail.variant.available;
			if (label) {
				label.textContent = e.detail.variant.available ? atc.dataset.labelAdd : atc.dataset.labelSoldOut;
			}
			this.syncVariantFromMainForm();
		}
		// Le tuto de la teinte choisie seul : les autres masqués (et leur aperçu en pause) ; sur une
		// fiche sans vidéos de gamme, le rail entier suit. Libellés « (n/total) » recomptés, rail
		// ramené au début, flèches recalculées. Seule la teinte de SA section compte : l'aperçu
		// rapide émet le même événement avec un autre `sectionId`.
		onTeinte(e) {
			if (!e.detail || !e.detail.variant || e.detail.sectionId !== this.dataset.section) return;
			const id = String(e.detail.variant.id);
			let montre = false;
			this.teintes.forEach((li) => {
				const visible = li.dataset.cluutchVariante === id;
				li.hidden = !visible;
				if (visible) montre = true;
				else {
					const video = li.querySelector('video');
					if (video) video.pause();
				}
			});
			if (this.hasAttribute('data-cluutch-teintes-seules')) this.hidden = !montre;
			const liste = this.visibles();
			liste.forEach((tile, i) => {
				const base = tile.dataset.cluutchLibelle || this.dataset.cluutchLibelle;
				if (base) tile.setAttribute('aria-label', base + ' (' + (i + 1) + '/' + liste.length + ')');
			});
			this.track.scrollTo({ left: 0 });
			this.syncArrows();
		}
		close() {
			if (!this.lb) return;
			this.video.pause();
			this.lb.classList.remove('is-open');
			this.lb.hidden = true;
			document.body.classList.remove('cluutch-ugc-open');
			cancelAnimationFrame(this.raf);
			if (this.opener) this.opener.focus();
			if (!this.reduceMotion) {
				this.previews.forEach((v) => {
					const r = v.getBoundingClientRect();
					if (r.top < window.innerHeight && r.bottom > 0) v.play().catch(() => {});
				});
			}
		}
	}
	customElements.define('cluutch-ugc-reels', CluutchUgcReels);
}
